import { render, staticRenderFns } from "./ShiftMaster.vue?vue&type=template&id=bb0e72ea&scoped=true"
import script from "./ShiftMaster.vue?vue&type=script&lang=js"
export * from "./ShiftMaster.vue?vue&type=script&lang=js"
import style0 from "./ShiftMaster.vue?vue&type=style&index=0&id=bb0e72ea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0e72ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb0e72ea')) {
      api.createRecord('bb0e72ea', component.options)
    } else {
      api.reload('bb0e72ea', component.options)
    }
    module.hot.accept("./ShiftMaster.vue?vue&type=template&id=bb0e72ea&scoped=true", function () {
      api.rerender('bb0e72ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/attendance-v2/ShiftMaster.vue"
export default component.exports